import { REMINDERS_PAUSED_REASONS } from '@shared/core/billing'
import type { RemindersPausedReason } from '@shared/core/billing'
import type { ReactNode } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { FormattedText } from 'src/modules/core/components'
import { RemindersPausedNotice } from 'src/modules/event/components/reminders-paused-notice'
import { useUpdatePaymentMethod } from 'src/modules/payment/hooks/use-update-payment-method'
import {
  buildUpgradePlansPath,
  resolveUpgradeSourcePage,
  UPGRADE_TRIGGER_BY_PAUSED_REASON,
} from 'src/modules/payment/utils/upgrade-funnel-navigation'
import type { AppointmentTypePausedNoticeProps } from './appointment-type-paused-notice.interface'
import classes from './appointment-type-paused-notice.module.scss'

const NOTICE_MESSAGE_IDS: Record<RemindersPausedReason, string> = {
  [REMINDERS_PAUSED_REASONS.quota]: 'event.paused.appointmentType.notice',
  [REMINDERS_PAUSED_REASONS.subscriptionEnded]: 'event.paused.appointmentType.noticeEnded',
  [REMINDERS_PAUSED_REASONS.paymentPaused]: 'event.paused.appointmentType.noticePaymentPaused',
}

export function AppointmentTypePausedNotice({ reason, freeRemindersLimit }: AppointmentTypePausedNoticeProps) {
  const { pathname, search } = useLocation()
  const { openUpdateCard, isAvailable } = useUpdatePaymentMethod()
  const plansPath = buildUpgradePlansPath({
    trigger: UPGRADE_TRIGGER_BY_PAUSED_REASON[reason],
    source_element: 'appointment_type_editor',
    source_page: resolveUpgradeSourcePage(pathname, new URLSearchParams(search)),
  })

  return (
    <RemindersPausedNotice variant="inline" className={classes.notice}>
      <FormattedText
        id={NOTICE_MESSAGE_IDS[reason]}
        values={{ limit: freeRemindersLimit, strong: (chunks: ReactNode) => <strong>{chunks}</strong> }}
      />{' '}
      {reason === REMINDERS_PAUSED_REASONS.paymentPaused ? (
        <button type="button" className={classes.linkButton} onClick={openUpdateCard} disabled={!isAvailable}>
          <FormattedText id="event.paused.appointmentType.linkUpdateCard" />
        </button>
      ) : (
        <Link to={plansPath}>
          <FormattedText id="event.paused.appointmentType.link" />
        </Link>
      )}
    </RemindersPausedNotice>
  )
}
